// Files module routes — arquivos compartilhados (dentro de Documentos)
import { lazy } from "react";
import { ModuleRoutes } from "../types";

const SharedFilesPage = lazy(() => import("@/pages/files/SharedFilesPage"));

export const filesRoutes: ModuleRoutes = {
  moduleId: "files",
  basePath: "/documentos",
  routes: [
    // URL canônica nova
    {
      path: "/documentos/compartilhados",
      element: <SharedFilesPage />,
      permission: { resource: "documents", action: "read" },
    },
    // Alias backwards-compat (URL antiga ainda funciona, mas sumiu do menu)
    {
      path: "/arquivos",
      element: <SharedFilesPage />,
      permission: { resource: "documents", action: "read" },
    },
  ],
};
